module.exports = __webpack_public_path__ + "static/q8-bf620bcddd75ba0ec466e2dc06ca41db.png";